import { DefaultError, QueryClient, QueryKey, useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import { passengerCMSApi } from "~/Services";

interface DocumentDetailsResponse {
  id?: number | string;
  title: string;
  airports: string[];
  body: string;
  link: string;
  sequence: number;
  published: boolean;
  description: string;
  banner: string;
}

// edit api call
const fetchSubCategoriesDetails = async (id: string): Promise<any> => {
  if (!id) {
    return null;
  }
  const response: any = await passengerCMSApi.get(`/api/get-spotlight-section-three/${id}`);
  return response.data[0];
};

const useSubCategoriesDocumentDetails = (
  id: string,
  options?: UseQueryOptions<DocumentDetailsResponse, DefaultError, DocumentDetailsResponse, QueryKey>,
  queryClient?: QueryClient
): UseQueryResult<DocumentDetailsResponse, DefaultError> => {
  return useQuery<DocumentDetailsResponse, DefaultError, DocumentDetailsResponse, QueryKey>(
    {
      queryKey: ["subCategoriesDocumentDetails", id],
      enabled: false,
      queryFn: () => {
        return fetchSubCategoriesDetails(id);
      },
      refetchOnWindowFocus: false,
      ...options,
    },
    queryClient
  );
};

export { useSubCategoriesDocumentDetails };
